import { useEffect, useMemo } from "react";
import { useSellerStore } from "src/store/sellers/sellers.store";
import { Seller } from "src/types/sellers";
import {
  groupSellersByPosition,
  RankedPosition,
} from "../utils/ranking-helpers";

interface UseRankingParams {
  startDate?: string;
  endDate?: string;
}

export function useRanking({ startDate, endDate }: UseRankingParams = {}) {
  const sellers = useSellerStore((state) => state.sellers) || [];
  const { loading, fetchSellers } = useSellerStore((state) => state);

  useEffect(() => {
    // Buscar todos os sellers sem paginação para o ranking
    fetchSellers({
      perPage: 1000,
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
    });
  }, [fetchSellers, startDate, endDate]);

  const rankedSellers = useMemo(() => {
    // Filtrar apenas sellers ativos e ordenar por userCount (maior para menor)
    return sellers
      .filter((seller) => seller.status === "active")
      .sort((a, b) => (b.userCount || 0) - (a.userCount || 0));
  }, [sellers]);

  const rankedPositions = useMemo(() => {
    return groupSellersByPosition(rankedSellers);
  }, [rankedSellers]);

  return {
    rankedSellers,
    rankedPositions,
    loading,
  };
}
